import { dateOptionsLong } from "../../constants";
import { getCurrentTime, DateFromISO } from "../../dependencies";
DateFromISO();
let formatCallback;
export const buildHeadingsDateFormatter = (getDateFormatter, overrideOptions = false) => {
    let options = Object.assign({}, dateOptionsLong);
    if (!formatCallback || overrideOptions) {
        formatCallback = formatIsoDateTime.bind(undefined, getDateFormatter(options));
    }
    return formatCallback;
};
function formatIsoDateTime(formatter, isoDateTime, timeZone) {
    const currentDateTime = Date.fromISO(isoDateTime);
    if (!currentDateTime) {
        return "";
    }
    const dateTime = getCurrentTime(currentDateTime, timeZone);
    return formatter.format(dateTime);
}
//# sourceMappingURL=buildHeadingsDateFormatter.js.map